module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centerft"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter01"
    }
  }), _vm._v("PRAISE FOR KENNETH STEVEN")]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('i', [_vm._v("Glen Lyon")]), _vm._v(" (2013)")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_vm._v("‘Robustly and sensitively explores the debilitating consequences of abuse, violence and the lack of love. It promises even greater things to follow’")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_c('i', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SCOTLAND ON SUNDAY")])])]), _vm._v(" "), _c('p', {
    staticClass: "centerf2"
  }, [_vm._v("‘This is no ordinary love story but a complex tale of two people feeling their way towards each other […] wonderful descriptions of a landscape and weather unique to Scotland’")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_c('i', [_c('span', {
    staticClass: "small"
  }, [_vm._v("SCOTTISH HOME AND COUNTRY")])])]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_c('i', [_vm._v("Evensong")]), _vm._v(" (2011)")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_vm._v("‘This collection of poems by Kenneth Steven is stunning. There is a grave beauty in these lines, revealing a poetic voice of great sensitivity. These poems are, quite simply, wonderful’")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ALEXANDER M")]), _vm._v("c"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CALL SMITH")])]), _vm._v(" "), _c('p', {
    staticClass: "centerf2"
  }, [_vm._v("‘For those of us who know Scotland, though not as natives, and for those of us who are forever attempting to know ourselves, Kenneth Steven is another inner voice, and never more so than in this collection of his work. "), _c('i', [_vm._v("Evensong")]), _vm._v(" is intimate and beautiful’")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RONALD BLYTHE")])]), _vm._v(" "), _c('p', {
    staticClass: "centerf2"
  }, [_c('i', [_vm._v("The Ice and Other Stories")]), _vm._v(" (2010)"), _c('br'), _vm._v("‘Beautiful, enchanting, heartbreaking’")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHRIS DOLAN")])]), _vm._v(" "), _c('p', {
    staticClass: "centerf2"
  }, [_vm._v("‘"), _c('i', [_vm._v("The Ice")]), _vm._v(" is an atmospheric, wintry tale of fragile human relationships set in a beautiful but unforgiving landscape’")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("JAMES ROBERTSON")])]), _vm._v(" "), _c('p', {
    staticClass: "centerf2"
  }, [_c('i', [_vm._v("‘The Ice")]), _vm._v(" comes straight out of a tradition running through Neil Gunn and Robin Jenkins – precise, sweetly written, slow moving and with a melancholy air in an uncontrived style’")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DES DILLON")])]), _vm._v(" "), _c('p', {
    staticClass: "centerf2"
  }, [_vm._v("‘A wonderful short-story writer – a very beautiful, enjoyable collection from a multi-talented writer’")]), _vm._v(" "), _c('p', {
    staticClass: "centerf1"
  }, [_c('i', [_c('span', {
    staticClass: "small"
  }, [_vm._v("OSPREY JOURNAL")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a677eeae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter01.vue
// module id = 60
// module chunks = 0